<div class="top-nav s-12 m-12 l-6">
    <!--Zoekfunctie -->
    <form class="customform" action="">
        <div class="s-12 m-12 l-12 margin-top-10">
            <app-searchbar></app-searchbar>
        </div>               
    </form>

</div>